import { createContext, useContext } from 'react';

const LiveResultsContext = createContext(null);

export const useLiveResultsContext = () => {
  const context = useContext(LiveResultsContext);

  if (!context) {
    throw new Error('useLiveResultsContext must be used within LiveResultsProvider.');
  }

  return context;
};

export default LiveResultsContext;
